<template>
  <div>
    <el-row>
      <el-col :span="20">
        <el-form :model="searchForm" ref="searchForm" :inline="true" label-width="140px" style="margin-top:20px;"
          id="searchForm">
          <el-form-item label="页面条数设置：" style="font-size: 16px">
            <el-input size="medium" v-model="searchForm.item"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button size="medium" type="primary" @click="setting" style="float: right;margin-top:4px">设置</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>
<script>
export default {
  data() {
    return {
      searchForm: {
        item: '',
      },
    };
  },
  created() {
    if (localStorage.getItem('SMP_PAGE_COUNT')) {
      this.searchForm.item = localStorage.getItem('SMP_PAGE_COUNT');
    }
  },
  methods: {
    setting() {
      if (this.searchForm.item && (this.searchForm.item > 0) && !Number.isNaN(Number(this.searchForm.item)) && (Number(this.searchForm.item) % 1 === 0)) {
        if (this.searchForm.item > 500) {
          this.$message.show({ text: '页面条数最多不可以超过500', type: 'warning' });
          return false;
        }
        localStorage.setItem('SMP_PAGE_COUNT', this.searchForm.item);
        this.$message.show({ text: '设置成功', type: 'success' });
      } else {
        this.$message.show({ text: '请输入正确的整数', type: 'warning' });
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/setting/setting.vue